module.exports = __webpack_public_path__ + "static/media/person-check.dfb5a007.svg";